<template>
    <b-container class="user-view">
        <button-row :Buttons="Buttons"></button-row>
        <b-row class="mt-0 mb-2">
            <b-col>
                <h3 class="mb-1">Allgemein</h3>
            </b-col>
        </b-row>
        <b-row >
            <b-col cols="6">
                <p>
                    <b>Kontaktdaten</b>
                    <br>{{edit_user.fe_user_salutation}} {{edit_user.fe_user_title}} {{edit_user.fe_user_firstname}} {{edit_user.fe_user_lastname}}
                    <span v-if="edit_user.fe_user_address"><br>{{edit_user.fe_user_address}}</span>
                    <span v-if="edit_user.fe_user_city"><br>{{edit_user.fe_user_zip}} {{edit_user.fe_user_city}}</span>
                </p>

                <p v-if="edit_user.fe_user_birthday_date">
                    <b>Geburtstag</b><br>{{user_birthday}}
                </p>

                <p>
                    <b>E-Mail</b>
                    <a :href="`mailto:${edit_user.fe_user_email_private}`" v-if="edit_user.fe_user_email_private"><span><br>{{edit_user.fe_user_email_private}} (privat)</span></a>
                    <a :href="`mailto:${edit_user.fe_user_email_business}`" v-if="edit_user.fe_user_email_business"><span><br>{{edit_user.fe_user_email_business}} (geschäftlich)</span></a>
                </p>


                <p>
                    <b>Telefon</b>
                    <a :href="`tel:${edit_user.fe_user_phone_private}`" v-if="edit_user.fe_user_phone_private"><span><br>{{edit_user.fe_user_phone_private}} (privat)</span></a>
                    <a :href="`tel:${edit_user.fe_user_phone_business}`" v-if="edit_user.fe_user_phone_business"><span><br>{{edit_user.fe_user_phone_business}} (geschäftlich)</span></a>
                    <a :href="`tel:${edit_user.fe_user_mobile}`" v-if="edit_user.fe_user_mobile"><span><br>{{edit_user.fe_user_mobile}} (mobil)</span></a>
                </p>

                <p>
                    <b>Mitgliedschaft</b>
                    <span v-if="edit_user.fe_user_active_bool"><br>Aktive Mitgliedschaft</span>
                    <span v-if="edit_user.fe_user_suspend_bool"><br>Beurlaubt</span>
                    <span v-if="edit_user.fe_user_guestmember_bool"><br>Gastmitglied</span>
                </p>

                <template v-if="user_roles.length > 0">
                    <p>
                        <b>Ämter</b>
                    </p>
                    <ul>
                        <!-- basti / mayo co-production \m/ -->
                        <template v-for="(ur, ur_i) in user_roles">
                            <li :key="ur_i"  v-if="edit_user.fe_user_roles.indexOf(ur.value) >= 0">{{ur.text}}</li>
                        </template>
                    </ul>
                </template>
            </b-col>
            <b-col cols="6">
                <template v-if="edit_user.fe_user_photo">
                <div class="user_img" :style="edit_user.fe_user_photo ? {backgroundImage: `url(${encodeURI(edit_user.fe_user_photo.sizes.Preview)})`} : ''">
                </div>
                </template>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ButtonRowVue from '../components/ButtonRow.vue';
export default {
    name: 'user-edit-cmp',
    components: {
        'button-row': ButtonRowVue,
    },
    props: {},
    data() {
        return {
            user_id: false,
            edit_user: { 
                fe_user_roles: [],
                fe_user_photo: null
            },
            user_img: null,
        }
    },
    mounted() {
        this.fetchUserRoles();
        this.user_id = false;
        if (this.$route.params.Id != "false") {

            if(this.$route.name == 'my-profile') {
                this.user_id = this.getUserId;
            } else {
                this.user_id = this.$route.params.Id;
            }
        } else if (this.$route.name == 'my-profile') {
            this.user_id = this.getUserId;
        }

        if (typeof this.user_id == undefined || this.user_id == 'my-profile') {
            this.user_id = this.getUserId;
        }

        if (this.user_id == false && this.$route.params.Id == 'my-profile') {
            this.logout();
        }
        this.init();
    },
    computed: {
        ...mapGetters('auth', ['loggedIn', 'isActivity', 'isMemberAdmin', 'getUserId']),
        ...mapGetters('events', ['user_roles']),
        ...mapGetters('members', ['fetching', 'member', 'uploading']),

        back_button_path() {
            return '/user-list';
        },

        user_birthday() {
            if(this.edit_user.fe_user_birthday_date) {
                let birthday = new Date(this.edit_user.fe_user_birthday_date);
                const ye = new Intl.DateTimeFormat('de', {year: 'numeric'}).format(birthday);
                const mo = new Intl.DateTimeFormat('de', {month: 'short'}).format(birthday);
                const da = new Intl.DateTimeFormat('de', {day: '2-digit'}).format(birthday);
                return da + ". " + mo + " " + ye;
            }else{
                return false;
            }
        },

        Buttons() {
            const buttons = [];
                buttons.push(
                    {
                        title: 'Zurück',
                        to: '/user-list',
                        variant: 'light border',
                        icons: {
                            left: {
                                icon: ['far', 'arrow-left'],
                                visible: true
                            },
                            right: {
                                icon: ['far', 'arrow-right'],
                                visible: false
                            }
                        }
                    }
                );

            return buttons;
        }
    },
    watch: {
        fetching(newValue) {
            if (newValue == false) {
                this.edit_user = { ...this.member};
            }
        }
    },
    methods: {
        ...mapActions('members', ['fetchMember', 'saveMember', 'uploadUserImage']),
        ...mapActions('events', ['fetchUserRoles']),
        ...mapActions('auth', ['logout']),

        init() {
            // console.log(this.$route);
            if (this.user_id) {
                // console.log('fetch member', this.user_id);
                this.fetchMember(this.user_id);
                // console.log(this.edit_user.fe_user_roles);
            }
        }
    }
}
</script>

<style lang="scss">
@import '../scss/variables';
.user-view {
    .user_img {
        margin-top: 0px;
        position: relative;
        border: 1px solid $primary;
        height: 240px;
        width: 100%;
        background-color: $info;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
    }

    ul.user-roles {
        padding:0 0 0 15px;
        li {
            display:block;
        }
    }
}
</style>